import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  LoadingButton,
} from '@one-thd/sui-atomic-components';

interface RemoveItemModalProps {
  onConfirmRemove: () => Promise<void>;
  onCancelRemove: () => void;
}

const RemoveItemModal = ({
  onConfirmRemove,
  onCancelRemove,
}: RemoveItemModalProps) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const handleRemoveClick = () => {
    setIsLoading(true);
    onConfirmRemove().finally(() => {
      setIsLoading(false);
    });
  };

  return (
    <Modal
      open
      onClose={isLoading ? () => undefined : onCancelRemove}
      size="sm"
      data-testid="remove-item-modal"
    >
      <ModalHeader onClose={isLoading ? undefined : onCancelRemove}>
        Remove Item?
      </ModalHeader>
      <ModalBody>
        Are you sure you want to remove this item from your return? You can
        still return the item within the return window.
      </ModalBody>
      <ModalFooter>
        <div className="sui-w-full sui-flex sui-flex-col sui-gap-[15px]">
          <LoadingButton
            variant="primary"
            onClick={handleRemoveClick}
            fullWidth
            loading={isLoading}
            data-testid="confirm-action"
          >
            Yes, Remove It
          </LoadingButton>
          <Button
            variant="secondary"
            onClick={onCancelRemove}
            fullWidth
            // Held shut while the removal is in flight. The item is taken out
            // of the return before the calls go out, so a customer who backs
            // out here would be dismissing a removal that still completes —
            // and would watch the item stay gone with the modal closed.
            disabled={isLoading}
            data-testid="cancel-action"
          >
            No, Keep the Item
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveItemModal;
